import { render, staticRenderFns } from "./IP_PxSummary.vue?vue&type=template&id=e193f332&scoped=true&"
import script from "./IP_PxSummary.vue?vue&type=script&lang=js&"
export * from "./IP_PxSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e193f332",
  null
  
)

export default component.exports